/**
 * Permission strings. Registry entries reference these (e.g. a calibration
 * service requires `calibration.execute`). A permission is necessary but never
 * sufficient: the backend also checks resource scope and, for motion/physical
 * actions, control ownership.
 */
export const PERMISSIONS = [
    "robot.view",
    "robot.manage",
    "telemetry.view",
    "mission.request",
    "mission.cancel",
    "mission.view",
    "map.view",
    "map.edit",
    "config.deploy",
    "calibration.execute",
    "recovery.execute",
    /** Record the outcome of a command the platform could not establish (`unknown`). */
    "outcome.resolve",
    "teleop.drive",
    /** Move the arm remotely: named poses, gripper, tool change (planned, collision-checked moves). */
    "teleop.arm",
    "control.request",
    "control.takeover",
    "estop.trigger",
    "estop.reset",
    "diagnostics.view",
    "audit.view",
    "registry.manage",
    "errors.manage",
    "users.manage",
];
const OPERATOR = [
    "robot.view",
    "telemetry.view",
    "mission.request",
    "mission.cancel",
    "mission.view",
    "map.view",
    "recovery.execute",
    "control.request",
    "estop.trigger",
];
const TECHNICIAN = [
    ...OPERATOR,
    "map.edit",
    "config.deploy",
    "calibration.execute",
    "teleop.drive",
    "teleop.arm",
    "estop.reset",
    "diagnostics.view",
    "outcome.resolve",
];
export const ROLE_PERMISSIONS = {
    operator: OPERATOR,
    technician: TECHNICIAN,
    admin: [...PERMISSIONS],
    // Integrators may submit/observe missions only; never teleop, calibrate or reconfigure.
    integrator: ["robot.view", "telemetry.view", "mission.request", "mission.cancel", "mission.view", "map.view", "control.request"],
    // Fleet adapter acts on behalf of OpenRMF: missions + state, nothing else.
    fleet_adapter: ["robot.view", "telemetry.view", "mission.request", "mission.cancel", "mission.view", "map.view", "control.request"],
};
export function permissionsForRoles(roles) {
    const out = new Set();
    for (const r of roles)
        for (const p of ROLE_PERMISSIONS[r])
            out.add(p);
    return out;
}
//# sourceMappingURL=permissions.js.map